export interface MarketParams {
  Name: string;
  NodeId: string;
  SportHandle: string;
  LeagueName: string;
  StartDate: string;
  SportName: string;
  teamAway?: string;
  teamHome?: string;
  StatisticsId?: string;
  pitcherHome?: string;
  pitcherAway?: string;
  LTMEnabled?: boolean;
  ParentNodeId?: string;
}
